import Glide from '@glidejs/glide';
import Sizes from '../../../components/shared/glide_fixed_width_slides';

const options = {
  type: 'carousel',
  startAt: 0,
  gap: 24,
  perView: 2.2,
  slideWidth: 376,
  peek: {
    before: 0,
    after: 0,
  },
  breakpoints: {
    1290: {
      perView: 1.5,
    },
    1000: {
      perView: 2.2,
    },
    800: {
      perView: 2,
      slideWidth: 330,
    },
    675: {
      perView: 1.5,
    },
    550: {
      perView: 1.15,
    },
  },
};

document
  .querySelectorAll('.marketplace-cards-section__cards.glide')
  .forEach((el) => {
    const cardsGlider = new Glide(el, options);
    cardsGlider.mount(Sizes);
  });
